module.exports = __webpack_public_path__ + "static/media/distancing.fe262554.png";